export const EquipmentScheduleController = {
    index(): void {},
};
